import { call, put } from "redux-saga/effects";
import {
    requestGetCalendarStatus,
    requestGetMeetings,
    requestGetManagerReport,
    requestGetManagerReportDrilldown,
    requestScheduleMeeting,
    requestGetMeetingSlots,
    requestRecordMeetingTime,
    requestSetMeetingManualTrack,
    requestSetUserCalendarOptOut,
} from "../requests/calendar";
import { setCalendarStatus } from "../../slices/calendar";
import { showAlert } from "../../slices/alerts";
import { safeErrorMessage } from "../../../utils/errorUtils";

export function* handleGetCalendarStatus() {
    try {
        const response = yield call(requestGetCalendarStatus);
        yield put(setCalendarStatus(response.data || {}));
    } catch (error) {
        yield put(setCalendarStatus({ enabled: false, optOut: false, connected: false }));
    }
}

export function* handleGetMeetings(action) {
    const { query, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestGetMeetings, query);
        if (callback) yield call(callback, response.data || {});
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
    }
}

export function* handleGetManagerReport(action) {
    const { query, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestGetManagerReport, query);
        if (callback) yield call(callback, { ...response.data, filters: query });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
    }
}

export function* handleScheduleMeeting(action) {
    const { payload, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestScheduleMeeting, payload);
        if (callback) yield call(callback, response.data);
    } catch (error) {
        const status = error.response?.status;
        if (errorCallback) {
            yield call(errorCallback, error);
        }
        if (status !== 409) {
            const message = safeErrorMessage(error);
            yield put(showAlert({ severity: "error", message }));
        }
    }
}

export function* handleGetMeetingSlots(action) {
    const { callback, errorCallback, ...body } = action.payload || {};
    try {
        const response = yield call(requestGetMeetingSlots, body);
        if (callback) yield call(callback, response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
        if (callback) yield call(callback, null);
    }
}

export function* handleRecordMeetingTime(action) {
    const { meetingId, payload, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestRecordMeetingTime, meetingId, payload);
        if (callback) yield call(callback, response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
    }
}

export function* handleSetMeetingManualTrack(action) {
    const { meetingId, tracked, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestSetMeetingManualTrack, meetingId, { tracked });
        if (callback) yield call(callback, response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
    }
}

export function* handleGetManagerReportDrilldown(action) {
    const { query, callback, errorCallback } = action.payload || {};
    try {
        const response = yield call(requestGetManagerReportDrilldown, query);
        if (callback) yield call(callback, response.data);
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (errorCallback) yield call(errorCallback, error);
    }
}

export function* handleSetUserCalendarOptOut(action) {
    const { userId, optOut, callback } = action.payload || {};
    try {
        const response = yield call(requestSetUserCalendarOptOut, userId, { optOut });
        if (callback) yield call(callback, { ok: true, data: response.data });
    } catch (error) {
        const message = safeErrorMessage(error);
        yield put(showAlert({ severity: "error", message }));
        if (callback) yield call(callback, { ok: false, message });
    }
}
